import React, { useEffect, useState, useRef } from "react";
import { useMusic } from "../context/MusicContext";
import {
  Box,
  VStack,
  HStack,
  Text,
  Image,
  IconButton,
  useColorMode,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Button,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import {
  FiPlay,
  FiPause,
  FiSkipBack,
  FiSkipForward,
  FiHeart,
  FiRepeat,
  FiShuffle,
  FiVolume2,
  FiList,
  FiDownload,
  FiAlignLeft,
  FiToggleLeft,
  FiArrowLeft,
  FiArrowRight,
} from "react-icons/fi";

import { TbRepeatOnce,TbRepeat  } from "react-icons/tb";
import { PiHeartStraightFill } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
const MotionBox = motion(Box);



function Player() {
  const [isFAV , setIsFAV] = useState(false);
  const { colorMode } = useColorMode();
  const navigate = useNavigate();
  const { isLoop, setIsLoop, playRandom ,playNext,playPrevious, audioRef, currentTime, currentTrack, setCurrentTrack,isPlaying, setIsPlaying } =
    useMusic();

  const User = useRef(JSON.parse(Cookies.get("User")));



  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  const handleSliderChange = (value) => {
    audioRef.current.currentTime = value;
  };
  


  useEffect(()=>{
    axios.get(`https://apiArmanify.zx-tm.ir/api/FevSongs/isFave/${User.current.userId}?url=${currentTrack.url}`)
      .then(res => {
        setIsFAV(true);
      })
      .catch(err => {
        console.log(false);
      });
  },[]);


  function Add_FAV(){

    if(isFAV){
      axios.post(`https://apiArmanify.zx-tm.ir/api/FevSongs/delete/${User.current.userId}?url=${currentTrack.url}`)
      .then(res => {
        setIsFAV(false);
      })
      .catch(err => {
        alert("خطا در حذف از علاقه مندی");
        setIsFAV(true);
      });
      
    }else{
      axios.post(`https://apiArmanify.zx-tm.ir/api/FevSongs/create?songId=${currentTrack.page_url}&songUrl=${currentTrack.url}&userId=${User.current.userId}`)
      .then(res => {
        setIsFAV(true);
      })
      .catch(err => {
        alert("خطا در اضافه کردن به علاقه مندی");
        setIsFAV(false);
      });
    }

  }

  return (
    <Box
      h="100vh"
      bg={colorMode === "dark" ? "gray.900" : "white"}
      position="relative"
      overflow="hidden"
    >
      {/* Background Image with Blur */}
      <Box
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bgImage={`url('${currentTrack.cover}')`}
        bgSize="cover"
        bgPosition="center"
        filter="blur(20px)"
        opacity="0.3"
      />

      {/* Content */}
      <VStack
        position="relative"
        h="100%"
        justify="space-between"
        p={8}
        spacing={8}
      >
        {/* Header */}
        <HStack w="100%" justify="space-between">
          <IconButton
          icon={<FiArrowRight/>}
            variant="ghost"
            onClick={() => navigate(-1)}
            color={colorMode === "dark" ? "white" : "gray.800"}
          >
            
          </IconButton>
        </HStack>

        {/* Album Art */}
        <MotionBox
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          whileHover={{ scale: 1.05 }}
        >
          <Image
            src={currentTrack.cover}
            alt="Album art"
            boxSize="300px"
            borderRadius="xl"
            boxShadow="2xl"
          />
        </MotionBox>

        {/* Song Info */}
        <VStack spacing={2} w="100%">
          <Text fontSize="1xl" fontWeight="bold">
            {currentTrack.title}
          </Text>
        </VStack>

        {/* Progress Bar */}
        <VStack w="100%" spacing={2}>
          <Slider
            value={currentTime}
            min={0}
            max={audioRef.current.duration}
            onChange={handleSliderChange}
            colorScheme="brand"
          >
            <SliderTrack>
              <SliderFilledTrack />
            </SliderTrack>
            <SliderThumb />
          </Slider>
          <HStack w="100%" justify="space-between">
            <Text fontSize="sm" color="gray.500">
              {formatTime(audioRef.current.duration)}
            </Text>
            <Text fontSize="sm" color="gray.500">
              {formatTime(currentTime)}
            </Text>
          </HStack>
        </VStack>

        {/* Controls */}
        <VStack spacing={6} w="100%">
          <HStack justify="space-between" w="100%">
            <IconButton
              icon={<FiShuffle />}
              variant="ghost"
              aria-label="Shuffle"
              fontSize="20px"
              onClick={() => playRandom()}
            />
            <IconButton
              icon={<FiSkipBack />}
              variant="ghost"
              aria-label="Previous"
              fontSize="24px"
              onClick={()=>playNext()}
            />
            <IconButton
              icon={isPlaying ? <FiPause /> : <FiPlay />}
              colorScheme="brand"
              rounded="full"
              size="lg"
              onClick={() => {
                setIsPlaying(!isPlaying);
              }}
              aria-label={isPlaying ? "Pause" : "Play"}
              fontSize="24px"
            />
            <IconButton
              icon={<FiSkipForward />}
              variant="ghost"
              aria-label="Next"
              fontSize="24px"
              onClick={()=>playPrevious()}
            />
            <IconButton
              icon={isLoop ? <TbRepeatOnce/> : <TbRepeat/>}
              variant="ghost"
              aria-label="Repeat"
              fontSize="20px"
              onClick={() => setIsLoop(!isLoop)}
            />
          </HStack>

          <HStack w="100%" justify="space-between">
            <a href={currentTrack.url}>
              <IconButton
                icon={<FiDownload />}
                variant="ghost"
                aria-label="download"
              />
            </a>
            <IconButton
            onClick={() => Add_FAV()}
              icon={isFAV ? <PiHeartStraightFill/> : <FiHeart />}
              variant="ghost"
              colorScheme="red"
              aria-label="Add to favorites"
            />
          </HStack>
        </VStack>
      </VStack>
    </Box>
  );
}

export default Player;
